{
  "modal": {
    "header": "Mappé à"
  },
  "company_industry": "Industrie de l'entreprise",
  "choose_internal_industries": "Choisir les industries internes à mapper",
  "select_internal_industries_placeholder": "Sélectionner les industries internes"
}
